import React, { useEffect, Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import {
  Box,
  Link,
  Card,
  InputLabel,
  Select,
  MenuItem,
  CardContent,
  makeStyles,
  Grid,
  colors,
  Avatar,
  Icon,
  Typography,
  Button,
  TextField,
  InputAdornment,
  SvgIcon,
  TablePagination,
  Paper,
  FormControl,
  Checkbox,
  FormGroup,
  FormControlLabel,
  ListItemText,
} from '@material-ui/core';

import { Search as SearchIcon } from 'react-feather';
import Add from '@material-ui/icons/AddCircleOutline';
import { BsPinAngleFill } from "react-icons/bs";

import Pager from 'src/utils/Pager';

const useStyles = makeStyles((theme) => ({
  root: {

  },
  avatar: {
    marginRight: theme.spacing(2),
    backgroundColor: colors.grey[200],
    width: 58,
    height: 58
  },
  iconoperation: {
    width: 45,
    height: 45
  },
  baroperation: {
    width: '100%',
    minHeight: 65
  }
}));

const ColorCheckbox = withStyles({
  root: {
    marginLeft: 0,
    color: colors.cyan[400],
    '&$checked': {
      color: colors.cyan[500],
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);


const LEVEL_ACCESS_HIDE = -1;
const LEVEL_ACCESS_DISABLED = 0;
const LEVEL_ACCESS_ENABLED = 1;


const Toolbar = ({ icon, item, resultset, resultModes, vision, visions, selectedMode, openCreation, changeFilter, openView }) => {

  const classes = useStyles();

  const [keyword, setKeyword] = useState('');
  const [query, setQuery] = useState(vision);
  const [page, setPage] = useState(0);
  const [rows, setRows] = useState(10);
  const [pointed, setPointed] = useState(false);
  const [state, setState] = useState(-1);
  const [cyties, setCyties] = useState([]);
  const [teams, setTeams] = useState([]);
  const [regions, setRegions] = useState([]);

  const existsCoords = (rows) => {
    for (let index = 0; index < rows.length; index++) {
      const element = rows[index];
      if (element.longitude && element.latitude) {
        return true
      }
    }
    for (let index = 0; index < rows.length; index++) {
      const element = rows[index];
      if (element.municipio) {
        if (element.municipio.longitude && element.municipio.latitude) {
          return true
        }
      }
    }
    return false;
  }

  const changeState = (event) => {
    setState(event.target.value);
    setPage(0);
    setCyties([]);
    changeFilter(
      query,
      keyword,
      0,
      rows,
      pointed,
      event.target.value,
      [],
      teams,
      regions);
  }

  const changeCyties = (event) => {
    setCyties(event.target.value);
    setPage(0);
    changeFilter(
      query,
      keyword,
      0,
      rows,
      pointed,
      state,
      event.target.value,
      teams,
      regions);
  }

  const changeTeams = (event) => {
    setTeams(event.target.value);
    setPage(0);
    changeFilter(
      query,
      keyword,
      0,
      rows,
      pointed,
      state,
      cyties,
      event.target.value,
      regions);
  }

  const changeRegions = (event) => {
    setRegions(event.target.value);
    setPage(0);
    changeFilter(
      query,
      keyword,
      0,
      rows,
      pointed,
      state,
      cyties,
      teams,
      event.target.value);
  }

  const changePointeds = (event) => {
    setPointed(event.target.checked);
    setPage(0);
    changeFilter(
      query,
      keyword,
      0,
      rows,
      event.target.checked,
      state,
      cyties,
      teams,
      regions);
  }

  const changeQuery = (event) => {
    setQuery(event.target.value);
    setPage(0);
    changeFilter(
      event.target.value,
      keyword,
      0,
      rows,
      pointed,
      state,
      cyties,
      teams,
      regions);
  }

  const changeKeyword = (event) => {
    setKeyword(event.target.value);
    setPage(0);
    changeFilter(
      query,
      event.target.value,
      0,
      rows,
      pointed,
      state,
      cyties,
      teams,
      regions);
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    changeFilter(
      query,
      keyword,
      newPage,
      rows,
      pointed,
      state,
      cyties,
      teams,
      regions);
  };

  const handleChangeRowsPerPage = (event) => {
    var rowsPerPage = parseInt(event.target.value, 10);
    setRows(rowsPerPage);
    setPage(0);
    changeFilter(
      query,
      keyword,
      page,
      rowsPerPage,
      pointed,
      state,
      cyties,
      teams,
      regions);
  };

  useEffect(() => {
    return
  }, []);

  return (
    <Fragment>
      <Box className={classes.baroperation}>

        <Grid container
          className={classes.baroperation}
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
        >
          <Grid item
            md="auto"
            xs={2}>
            <Avatar variant="rounded"
              className={classes.avatar}
            >
              {<Icon className={classes.iconoperation} component={icon} style={{ color: colors.cyan[500] }} ></Icon>}
            </Avatar>

          </Grid>

          <Grid item
            md="auto"
            xs="auto">

            <Typography
              color="primary"
              variant="h5"
            >
              Você esta na área de <b>{<Link color="inherit" href="/mgt/main">MANUTENÇÃO</Link>}</b>. A operação padrão é <b> {localStorage.getItem('company')}</b>
            </Typography>

            <Typography
              color="secondary"
              variant="h4"
            >
              <b>Unidades</b>
            </Typography>

          </Grid>
        </Grid>
      </Box>

      <Box>
        <Card>
          <CardContent>
            <Grid container
              fullWidth
              direction="row"
              justifyContent="flex-start"
              alignItems="flex-end"
            >
              <Grid item
                md={12}
                xs={12}>

                <Box mb={2}>
                  <Card>
                    <CardContent>
                      <Grid container
                        fullWidth
                        direction="row"
                        justify="flex-start"
                        alignItems="flex-start"
                        alignContent="flex-start"

                      >
                        <Grid item
                          xs={12}
                        >
                          <Grid container justifyContent="flex-start" spacing={2}>
                            <Grid item
                              md={3}
                              xs={12}
                            >
                              <FormControl variant="outlined" fullWidth>
                                <InputLabel shrink htmlFor="query">Pesquisa</InputLabel>
                                <Select notched
                                  required={true}
                                  fullWidth={true}
                                  label="Pesquisa"
                                  variant="outlined"
                                  id="query"
                                  name="query"
                                  value={query}
                                  onChange={changeQuery}
                                  inputProps={{
                                    name: 'query',
                                    id: 'query',
                                  }}
                                >
                                  {visions.map((view) => (
                                    <MenuItem key={view.id} value={view}>{view.name}</MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </Grid>

                            <Grid item
                              md={4}
                              xs={12}
                            >
                              <TextField
                                fullWidth
                                disabled={!query.refine}
                                onChange={changeKeyword}
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <SvgIcon
                                        fontSize="small"
                                        color="action"
                                      >
                                        <SearchIcon />
                                      </SvgIcon>
                                    </InputAdornment>
                                  )
                                }}
                                placeholder={"Refinar pesquisa por, " + query.label}
                                variant="outlined"
                                InputLabelProps={{ shrink: true }}
                              />
                            </Grid>

                            <Grid
                              item
                              md={1}
                              xs={12}>

                              <FormControl variant="outlined" fullWidth>
                                <InputLabel shrink htmlFor="state">UF</InputLabel>
                                <Select notched
                                  autosize={true}
                                  onChange={changeState}
                                  value={state}
                                  label="UF"
                                  variant="outlined"
                                  inputProps={{
                                    name: 'state',
                                    id: 'state',
                                  }}
                                >
                                  <MenuItem value={-1}>
                                    <em>Todas</em>
                                  </MenuItem>
                                  {resultset.states.map((uf) => (
                                    <MenuItem key={uf.UF} value={uf.UF}>{uf.UF}</MenuItem>
                                  ))}

                                </Select>
                              </FormControl>

                            </Grid>

                            <Grid
                              item
                              md={4}
                              xs={12}>

                              <FormControl variant="outlined" fullWidth>
                                <InputLabel shrink htmlFor="category">Municípios</InputLabel>
                                <Select notched
                                  id="cyties"
                                  multiple
                                  value={cyties}
                                  onChange={changeCyties}
                                  disabled={state == -1}
                                  fullWidth
                                  label="Municípios"
                                  name="cyties"
                                  variant="outlined"
                                  renderValue={(selected) => selected.join(', ')}
                                  inputProps={{
                                    name: 'cyties',
                                    id: 'cyties',
                                  }}
                                >

                                  {resultset.cyties.map((ct) => (
                                    <MenuItem key={ct.id} value={ct.nome}>
                                      <ColorCheckbox checked={cyties.indexOf(ct.nome) > -1} />
                                      <ListItemText primary={ct.nome} ></ListItemText>
                                    </MenuItem>
                                  ))}

                                </Select>
                              </FormControl>

                            </Grid>


                            <Grid
                              item
                              md={3}
                              xs={12}>

                              <FormControl variant="outlined" fullWidth>
                                <InputLabel shrink htmlFor="category">Rotas</InputLabel>
                                <Select notched
                                  id="regions"
                                  multiple
                                  value={regions}
                                  onChange={changeRegions}
                                  fullWidth
                                  label="Rotas"
                                  name="regions"
                                  variant="outlined"
                                  renderValue={(selected) => selected.join(', ')}
                                  inputProps={{
                                    name: 'regions',
                                    id: 'regions',
                                  }}
                                >

                                  {resultset.regions.map((rg) => (
                                    <MenuItem key={rg.id} value={rg.nome}>
                                      <ColorCheckbox checked={regions.indexOf(rg.nome) > -1} />
                                      <ListItemText primary={rg.nome} ></ListItemText>
                                    </MenuItem>
                                  ))}

                                </Select>
                              </FormControl>

                            </Grid>

                            <Grid
                              item
                              md={3}
                              xs={12}>

                              <FormControl variant="outlined" fullWidth>
                                <InputLabel shrink htmlFor="category">Equipes</InputLabel>
                                <Select notched
                                  id="teams"
                                  multiple
                                  value={teams}
                                  onChange={changeTeams}
                                  fullWidth
                                  label="Equipes"
                                  name="teams"
                                  variant="outlined"
                                  renderValue={(selected) => selected.join(', ')}
                                  inputProps={{
                                    name: 'teams',
                                    id: 'teams',
                                  }}
                                >

                                  {resultset.teams.map((tm) => (
                                    <MenuItem key={tm.id} value={tm.nome}>
                                      <ColorCheckbox checked={teams.indexOf(tm.nome) > -1} />
                                      <ListItemText primary={tm.nome} ></ListItemText>
                                    </MenuItem>
                                  ))}

                                </Select>
                              </FormControl>

                            </Grid>

                            <Grid
                              item
                              md={4}
                              xs={12}>
                              <FormGroup row>
                                <FormControlLabel
                                  control={<ColorCheckbox
                                    checked={pointed}
                                    onChange={changePointeds} name="pointed" />}
                                  label="Mostrar somente os com apontamento no mapa"
                                />
                              </FormGroup>

                            </Grid>


                          </Grid>

                        </Grid>

                      </Grid>

                    </CardContent>

                  </Card>
                </Box>

              </Grid>

              <Grid item
                md={9}
                xs={12}
              >
                <Grid container
                  direction="column"
                  justifyContent="flex-start"
                  alignItems="flex-start"
                >

                  <Grid item
                    md={10}
                    xs={12}
                  >

                    <TablePagination
                      style={{ minWidth: 295 }}
                      variant="caption"
                      component={Paper}
                      className={classes.pager}
                      page={page}
                      rowsPerPage={rows}
                      count={resultset.count}
                      labelRowsPerPage={(screen.width <= 480) ? "" : "Linhas por página"}
                      labelDisplayedRows={(screen.width <= 480) ? (({ from, to, count }) => `${from}-${to} de ${count}`) : (({ from, to, count }) => `Encontrados: ${count}, Apresentando de: ${from} a ${to}`)}
                      onChangePage={handleChangePage}
                      onChangeRowsPerPage={handleChangeRowsPerPage}
                      ActionsComponent={Pager}
                    />

                  </Grid>

                </Grid>

              </Grid>

              <Grid item
                md={3}
                xs={12}
              >
                <Grid container
                  direction="row"
                  justifyContent="baseline"
                  alignItems="flex-end"
                >

                  <Grid item
                    md="auto"
                    xs="auto"
                  >
                    {(resultModes[selectedMode].create != LEVEL_ACCESS_HIDE) ? (
                      <Box mt={2} >
                        <Button
                          color="secondary"
                          disabled={resultModes[selectedMode].create == LEVEL_ACCESS_DISABLED}
                          size="small"
                          variant="contained"
                          startIcon={<Add />}
                          onClick={() => { openCreation(item) }}>
                          Criar Unidade
                        </Button>
                      </Box>
                    ) : ('')}
                  </Grid>

                  <Grid item
                    md="auto"
                    xs="auto"
                  >
                    &nbsp;&nbsp;&nbsp;
                  </Grid>

                  <Grid item
                    md="auto"
                    xs="auto"
                  >
                    {(resultModes[selectedMode].view != LEVEL_ACCESS_HIDE) ? (
                      <Box mt={2} >
                        <Button
                          color="secondary"
                          disabled={resultModes[selectedMode].view == LEVEL_ACCESS_DISABLED || !existsCoords(resultset.rows)}
                          size="small"
                          variant="contained"
                          startIcon={<BsPinAngleFill />}
                          onClick={() => { openView(item) }}>
                          Visualizar no Mapa
                        </Button>
                      </Box>
                    ) : ('')}
                  </Grid>

                </Grid>

              </Grid>

            </Grid>

          </CardContent>

        </Card>

      </Box>

    </Fragment>

  );
};


Toolbar.propTypes = {
  className: PropTypes.string
};

export default Toolbar;
